import React from "react";
import { FileSearch } from "lucide-react";

export function EmptyState({ title = "No PDFs found", hint = "Try a different search term or category." }) {
  return (
    <div
      className="rounded-2xl border border-dashed border-slate-300 bg-white py-16 px-6 text-center"
      data-testid="empty-state"
    >
      <div className="mx-auto h-14 w-14 rounded-2xl bg-slate-100 text-slate-500 flex items-center justify-center mb-4">
        <FileSearch className="h-6 w-6" />
      </div>
      <h3 className="font-display text-xl font-bold text-slate-900">{title}</h3>
      <p className="text-sm text-slate-500 mt-1 max-w-md mx-auto">{hint}</p>
    </div>
  );
}
